module.exports = __webpack_public_path__ + "static/media/item_transfer.65f41ce8.svg";